import { useReducer, useState } from 'react';
function reducer(state, action) {
    switch (action.type) {
        case 'RESOLVE':
            return { value: action.value, error: undefined };
        case 'REJECT':
            return { value: false, error: action.error };
        case 'RESET':
            return { value: undefined, error: undefined };
        default:
            return state;
    }
}
export default function useResolver(resetKey) {
    const [previousResetKey, setPreviousResetKey] = useState(() => resetKey);
    const [state, dispatch] = useReducer(reducer, { value: undefined, error: undefined });
    // Reset before effects can report a result belonging to the previous input.
    if (!Object.is(previousResetKey, resetKey)) {
        setPreviousResetKey(() => resetKey);
        dispatch({ type: 'RESET' });
    }
    return [state, dispatch];
}
